// extracted by mini-css-extract-plugin
export var lightMode = "_5-0";